import { useTranslation } from 'react-i18next';

const useComputeOption = () => {
  const { t } = useTranslation();

  const computeOption = (option, category = 'cabinClass') => {
    return t(`${category}.${option}`);
  };

  return computeOption;
};

export default useComputeOption;
